import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledOnboardingHubProgressWrapper = styled(FlexColumn)<{ isInSidebar: boolean; isCentered?: boolean }>`
    gap: 12px;
    flex-grow: 1;
    justify-content: ${({ isCentered = false }) => (isCentered ? "center" : "flex-start")};
    margin-bottom: ${({ isInSidebar, isCentered = false }) => (isCentered ? "6px" : isInSidebar ? "16px" : 0)};
`;

export const StyledOnboardingHubTitleWrapper = styled(FlexRow)`
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    position: relative;
`;

export const StyledOnboardingHubTitle = styled(FlexRow)<{ isInSidebar?: boolean }>`
    ${({ isInSidebar }) => (isInSidebar ? `gap: 0; justify-content: space-between; width:100%` : `gap: 8px;`)};
    align-items: center;
`;

export const StyledOnboardingHubCloseButton = styled.div<{ isExtended?: boolean }>`
    ${({ isExtended }) =>
        !isExtended
            ? `
        position: absolute;
        top: -10px;
        right: -10px;
      `
            : `
        position: relative;
        top: 0;
        right: 0;
      `}
`;

export const StyledOnboardingHubButtonSmallTitle = styled.div`
    ${setFontVariant("button", colorsPalettes.carbon[500])};
    line-height: 16px;
    overflow: hidden;
    font-feature-settings: "liga" off;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
`;

export const StyledOnboardingHubButtonTitle = styled(StyledOnboardingHubButtonSmallTitle)`
    ${setFontVariant("h6", colorsPalettes.carbon[500])};
`;

export const StyledOnboardingHubButtonSubTitle = styled.div`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[300])};
    font-size: 13px;
    line-height: 13px;
    overflow: hidden;
    font-feature-settings: "liga" off;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledOnboardingHubButtonSubSmallTitle = styled(StyledOnboardingHubButtonSubTitle)`
    ${setFontVariant("caption2", colorsPalettes.carbon[400])};
`;
